import getTypeFromValue from '_utils/helpers/getTypeFromValue';

// note! enum values match keys sent by server
export enum AttributeType {
  capacity = 'capacity',
  cost = 'cost',
  lastUpdated = 'lastUpdated',
  location = 'location',
  statusIcon = 'statusIcon',
  statusName = 'statusName',
  time = 'time',
  timeSpecificity = 'timeSpecificity',
  timeUnit = 'timeUnit',
  timeEstimate = 'timeEstimate',
  costEstimate = 'costEstimate',
  costSpecificity = 'costSpecificity',
  whatsOnCost = 'whatsOnCost',
  newsDate = 'newsDate'
}

export type Attribute = {
  type: AttributeType;
  value: any;
};

/**
 * @param target either a string representation of a attribute type or an object containing a attribute type
 * @param key optional used to retrieve attributeType value (if passing an object)
 */
export const getAttributeType = (value: string | object, key: string = 'type'): AttributeType => getTypeFromValue<AttributeType>(AttributeType, value, key)

/**
 * @param target either a string representation of a attribute type or an object containing a attribute type
 * @param key optional used to retrieve attributeType value (if passing an object)
 */
export const pickAttributeByType = (
  attributes,
  attributeName: string,
  key: string = 'type'
): Attribute => {
  if (!attributes || !attributeName) {
    return null;
  }

  let attrs = attributes?.filter((attr) => attr[key] === attributeName);

  if (attrs.length) {
    const attr = attrs[0];
    let attrType: AttributeType = getAttributeType(attr, key);

    if (attrType !== undefined) {
      // found a known type
      return {
        ...attr,
        type: attrType
      };
    } else {
      // treat as generic
      return {
        ...attr,
        type: undefined
      };
    }
  }

  return null;
};

export const includesAttributeWithType = (
  attributes: { [key: string]: Attribute },
  type: AttributeType
) => {
  if (!attributes) {
    return false;
  }

  return attributes.hasOwnProperty(type);
};

export const includesAttributesWithTypes = (
  attributes: { [key: string]: Attribute },
  types: AttributeType[]
) => {
  if (!attributes || !types) {
    return false;
  }

  for (let i = 0; i < types.length; i++) {
    const type = types[i];
    if (!includesAttributeWithType(attributes, type)) {
      return false;
    }
  }

  return true;
};

// Old loose definitions Please migrate to strict ones above
// DELETED use pickAttributeByType
// export const getAttributeByType = (attributes, attributeType) => {

// };

// DELETED use AttributeIcon in utils/components/ContentTypeAttributes
// export const AttributeIcon = ({ attribute }) => {

// };
